<template>
  <div id="shopping">
        <tabtop></tabtop>
        <div class="shopping1"><img :src="url+banner.images[3]" alt=""  @click="jumpbannerpage(banner.url,3)"></div>
        <div class="shopping2">
            <p class="title">企业私域运营的三大壁垒</p>
            <ul>
                <li v-for="(item,index) in shopping2" :key="index"  class="wow animate__animated animate__fadeIn">
                    <img :src="item.img" alt="">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2" v-html="item.subtitle"></p>
                </li>
            </ul>
        </div>
        <div class="shopping3">
            <img src="@/assets/product/shopping3bg.png" alt="" class="bg">
            <div class="shopping3Box">
                <p class="title">—— 企业私域流量运营痛点</p>
                <ul>
                    <li v-for="(item,index) in shopping3" :key="index"  class="wow animate__animated animate__fadeIn">
                        <img :src="item.img" alt="">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2" v-html="item.subtitle"></p>
                    </li>
                </ul>
            </div>
        </div>
         <div class="shopping4">
            <p class="title"><span>——私域商城</span>助你线上开店无压力</p>
            <ul v-for="(item,index) in shopping4" :key="index" :class="[index%2==0?'other':'','wow','animate__animated','animate__fadeIn']">
                <li><img :src="item.img" alt="" class="cover"></li>
                <li class="list1">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p>
                    <button @click="submit(false)">免费试用</button>
                </li>
            </ul>
        </div>
        <div class="shopping5">
            <p class="title">营销运营 应用范围</p>
            <p class="subtitle">通过客户分层客户标签客户画像 SOP策略 数据分析 跟踪策略制定和执行提高客户的购买转化率，降低企业销售成本</p>
            <ul>
                <li v-for="(item,index) in shopping5" :key="index" class="wow animate__animated animate__fadeIn">
                    <img :src="item.img" alt="">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2" v-html="item.subtitle"></p>
                </li>
            </ul>
        </div>
        <webbottom></webbottom>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import mydialog from '@/components/dialog/dialog.vue'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"shopping",
    components: {
        tabtop,
        webbottom,
        mydialog
    },
    data(){
        return {
            url : window.url,
            banner:{},
            showtc2:false,
            tcshow:true,
            shopping2:[
                {
                    img:require("@/assets/product/shopping2img1.png"),
                    title:"运营初期",
                    subtitle:"缺乏标准高效工具及运<br/>营理论知识"
                },
                {
                    img:require("@/assets/product/shopping2img2.png"),
                    title:"运营中期",
                    subtitle:"私域运营互相割裂，难<br/>以形成运营闭环"
                },
                {
                    img:require("@/assets/product/shopping2img3.png"),
                    title:"运营后期",
                    subtitle:"客户新鲜度消失过快，难<br/>以长效维持及有效挖掘"
                }
            ],
            shopping3:[
                {
                    img:require("@/assets/product/shopping1.png"),
                    title:"获客成本高，用户留存难",
                    subtitle:"获客成本越来越高，有没有对用户做深度留存沉淀，不仅不利于沉淀复购，还浪费精力和成本。"
                },
                {
                    img:require("@/assets/product/shopping2.png"),
                    title:"工作效率低，服务质量差",
                    subtitle:"对用户无法达到高效的快捷回复统一管理，人力成本高且效率低。"
                },
                {
                    img:require("@/assets/product/shopping3.png"),
                    title:"微信个人号容易封号",
                    subtitle:"微信个人号安全性不高，添加频繁或操作不当容易封号"
                },
                {
                    img:require("@/assets/product/shopping4.png"),
                    title:"无法有效监管员工",
                    subtitle:"聊天记录无法追踪质检，容易造成私单，溜单等损害企业利益的行为无法有效监管。"
                },
                {
                    img:require("@/assets/product/shopping5.png"),
                    title:"各大电商平台数据割裂",
                    subtitle:"无法实现各大电商平台数据互通，各平台之前跳转流程繁琐。"
                },
                {
                    img:require("@/assets/product/shopping6.png"),
                    title:"缺乏背书，难有信任感",
                    subtitle:"缺乏官方身份认证背书，监管时缺乏品牌公信力，用户信任感不足。	"
                }
            ],
            shopping4:[
                {
                    img:require("@/assets/product/shopping7.png"),
                    title:"微信小程序开店",
                    subtitle:"亿宝易小程序直接开启店铺"
                },
                {
                    img:require("@/assets/product/shopping8.png"),
                    title:"客户浏览记录追踪",
                    subtitle:"客户访问商品记录实时追踪"
                },
                {
                    img:require("@/assets/product/shopping9.png"),
                    title:"客户动向实时通知商家",
                    subtitle:"客户下单、付款行为实时通知商家"
                },
                {
                    img:require("@/assets/product/shopping10.png"),
                    title:"多种营销玩法",
                    subtitle:"优惠券、拼单、拼团、分销、砍价等多种营销玩法提升销量"
                },
                {
                    img:require("@/assets/product/shopping11.png"),
                    title:"快速裂变分销",
                    subtitle:"快速拓展销售渠道，促进客户增长及业绩提升"
                },
                {
                    img:require("@/assets/product/shopping12.png"),
                    title:"精准数据分析提升效率",
                    subtitle:"多角度全方位分析店铺经营情况和客户情况"
                }
            ],
            shopping5:[
                {
                    img:require("@/assets/product/shopping13.png"),
                    title:"引流拉新",
                    subtitle:"利用微信公众号和企业微信的各项功能，实现裂变用户增长"
                },
                {
                    img:require("@/assets/product/shopping14.png"),
                    title:"客户运营",
                    subtitle:"客户分层客户标签画像客户属性自定义，多方位精细化运营客户用户管理"
                },
                {
                    img:require("@/assets/product/shopping15.png"),
                    title:"客户管理",
                    subtitle:"建立多层级细化权限的客户管理机制，企业统一管理"
                },
                {
                    img:require("@/assets/product/shopping16.png"),
                    title:"用户营销",
                    subtitle:"利用企业微信实现免费高效率的群发朋友圈营销等多种方式的信息触达"
                },
                {
                    img:require("@/assets/product/shopping17.png"),
                    title:"社群运营",
                    subtitle:"社群裂变，快速实现用户增长"
                }
            ],
        }
    },
    mounted(){
        that = this
        
        rotationmap({'type':8}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            that.$nextTick(function(){
                if(this.$route.query.id){
                    document.getElementById(this.$route.query.id).scrollIntoView();
                }
                //初始化动画
                setTimeout(() => {
                    that.$wow.init()
                }, 1000);
                
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #shopping{
        .shopping1{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .shopping2{
            width: 1400px;
            margin:60px auto 0;
            .title{
                 font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                justify-content: space-between;
                margin-top: 50px;
                li{
                    width: 300px;
                    height: 300px;
                    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                    border-radius: 48px 48px 48px 48px;
                    opacity: 1;
                    border: 1px solid #707070;
                    text-align: center;
                    img{
                        width: 100px;
                        margin-top: 40px;
                    }
                    .p1{
                         font-size: var(--web-subtitle-fontsize);
                        color: #FFFFFF;
                        margin:35px 0 10px;
                    }
                    .p2{
                         font-size: var(--web-text-fontsize);
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
                li:nth-child(1){
                    background: linear-gradient(315deg, #30B3B6 0%, #36B8BC 12%, #65E1E6 100%);
                }
                li:nth-child(2){
                    background: linear-gradient(315deg, #3B58E0 0%, #8499F8 100%);
                }
                li:nth-child(3){
                    background: linear-gradient(315deg, #F3760C 0%, #FFB06D 100%);
                }
            }
        }
        .shopping3{
            position: relative;
            width: 1400px;
            margin:60px auto 0;
            .bg{
                width: 1000px;
            }
            .shopping3Box{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: normal;
                    color: #fff;
                    padding-left: 200px;
                    margin-top: 40px;
                }
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    margin:40px 200px;
                    img{
                        width: 120px;
                    }
                    li{
                        width: 300px;
                        height: 300px;
                        background: #FFFFFF;
                        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                        border-radius: 48px 48px 48px 48px;
                        margin-bottom: 30px;
                        padding: 30px 20px;
                        .p1{
                            font-size: var(--web-subtitle-fontsize);
                            font-family: Segoe UI-Bold, Segoe UI;
                            font-weight: bold;
                            color: #3D3D3D;
                        }
                        .p2{
                            font-size: var(--web-text-fontsize);
                            font-family: Segoe UI-Regular, Segoe UI;
                            font-weight: 400;
                            color: #3D3D3D;
                            margin-top: 13px;
                        }
                    }
                }
            }
        }
        .shopping4{
            width: 1400px;
            margin:60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                padding-left: 100px;
                span{
                    color:#3B61C8;
                }
            }
            ul{
                display: flex;
                justify-content: space-between;
                margin-bottom: 70px;
                margin-top: 70px;
                li{
                    flex:0 0 50%;
                    .cover{
                        width: 100%;
                    }
                    .p1{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #355EFC;
                        margin-top: 98px;
                    }
                    .p2{
                        padding-left: 24px;
                        position: relative;
                        font-size: var(--web-text-fontsize);
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #1A1A1A;
                        width: 417px;
                        margin-top: 16px;
                    }
                    .p2::after{
                        content:"";
                        display: block;
                        width: 8px;
                        height: 8px;
                        position: absolute;
                        border: 4px solid #DBE2FE;
                        background-color: #355EFC;
                        border-radius: 50%;
                        top: 5px;
                        left: 0;
                    }
                    button{
                        width: 120px;
                        height: 46px;
                        background: #355EFC;
                        border-radius: 61px 61px 61px 61px;
                        font-size: var(--web-text-fontsize);
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        margin-top: 35px;
                    }
                }
                .list1{
                    padding-left: 50px;
                }
            }
            .other{
                flex-direction: row-reverse;
            }
        }
        .shopping5{
            width: 1400px;
            margin:60px auto 100px;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            .subtitle{
                width: 764px;
                font-size: var(--web-subtitle-fontsize);
                font-weight: 400;
                color: #8D8D8D;
                text-align: center;
                margin: 20px auto 40px;
            }
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    width: 264px;
                    height: 350px;
                    background: #FAFAFA;
                    border-radius: 20px 20px 20px 20px;
                    padding: 32px;
                    img{
                        width: 120px;
                    }
                    .p1{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: bold;
                        color: #4E4E4E;
                        margin:12px 0;
                    }
                    .p2{
                        font-size: var(--web-text-fontsize);
                        font-weight: 400;
                        color: #848484;
                    }
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #shopping{
        .shopping1{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .shopping2{
            width: 100%;
            margin:1.25rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin:1.25rem 0.625rem;
                li{
                    margin-bottom: 1.25rem;
                    flex:0 0 45%;
                    box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem;
                    opacity: 1;
                    border: 1px solid #707070;
                    text-align: center;
                    img{
                        width: 2.5rem;
                        margin-top: 1.25rem;
                    }
                    .p1{
                        font-size: 1rem;
                        color: #FFFFFF;
                        margin:0.625rem 0 0.625rem;
                    }
                    .p2{
                        font-size: 0.875rem;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
                li:nth-child(1){
                    background: linear-gradient(315deg, #30B3B6 0%, #36B8BC 12%, #65E1E6 100%);
                }
                li:nth-child(2){
                    background: linear-gradient(315deg, #3B58E0 0%, #8499F8 100%);
                }
                li:nth-child(3){
                    background: linear-gradient(315deg, #F3760C 0%, #FFB06D 100%);
                }
            }
        }
        .shopping3{
            position: relative;
            width: 100%;
            margin:3.75rem auto 0;
            .bg{
                width: 100%;
                display: none;
            }
            .shopping3Box{
                width: 100%;
                .title{
                    font-size: 1.5rem;
                    font-weight: normal;
                    color: #222222;
                    margin-top: 0.625rem;
                    text-align: center;
                }
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    margin:2.5rem 1.25rem;
                    img{
                        width: 2.5rem;
                    }
                    li{
                        flex:0 0 45%;
                        background: #FFFFFF;
                        box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                        border-radius: 1.25rem;
                        margin-bottom: 1.875rem;
                        padding: 1.875rem 1.25rem;
                        .p1{
                            font-size: 0.875rem;
                            font-family: Segoe UI-Bold, Segoe UI;
                            font-weight: bold;
                            color: #3D3D3D;
                        }
                        .p2{
                            font-size: 0.75rem;
                            font-family: Segoe UI-Regular, Segoe UI;
                            font-weight: 400;
                            color: #3D3D3D;
                            margin-top: 0.8125rem;
                        }
                    }
                }
            }
        }
        .shopping4{
            width: 100%;
            margin:1.25rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
                margin-bottom: 0.625rem;
                span{
                    color:#3B61C8;
                }
            }
            ul{
                display: flex;
                justify-content: space-between;
                margin-bottom: 4.375rem;
                margin-top: 4.375rem;
                flex-wrap: wrap;
                margin:0 0.625rem;
                li{
                    flex:0 0 100%;
                    .cover{
                        width: 100%;
                    }
                    .p1{
                        font-size: 1.25rem;
                        font-weight: 500;
                        color: #355EFC;
                        margin-top: 0.625rem;
                    }
                    .p2{
                        padding-left: 1.125rem;
                        position: relative;
                        font-size: 1.25rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #1A1A1A;
                        width: 26.0625rem;
                        margin-top: 0.625rem;
                    }
                    .p2::after{
                        content:"";
                        display: block;
                        width: 0.5rem;
                        height: 0.5rem;
                        position: absolute;
                        border: 4px solid #DBE2FE;
                        background-color: #355EFC;
                        border-radius: 50%;
                        top: 0.3125rem;
                        left: 0;
                    }
                    button{
                        width: 8.625rem;
                        height: 2.875rem;
                        background: #355EFC;
                        border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                        font-size: 0.875rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        margin: 1.25rem 0;
                    }
                }
            }
        }
        .shopping5{
            width: 100%;
            margin:1.25rem auto 1.25rem;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            .subtitle{
                font-size: 0.875rem;
                font-weight: 400;
                color: #8D8D8D;
                text-align: center;
                margin: 1.25rem auto 2.5rem;
            }
            ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin:0 0.625rem;
                li{
                    flex:0 0 45%;
                    background: #FAFAFA;
                    border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                    padding: 1.25rem;
                    margin-bottom: 0.625rem;
                    img{
                        width: 2.5rem;
                    }
                    .p1{
                        font-size: 1.5rem;
                        font-weight: bold;
                        color: #4E4E4E;
                        margin:0.75rem 0;
                    }
                    .p2{
                        font-size: 1.125rem;
                        font-weight: 400;
                        color: #848484;
                    }
                }
            }
        }
    }
 
}
</style>